import script from "./BrandsSelector.vue?vue&type=script&lang=js"
export * from "./BrandsSelector.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__